import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function AboutSection() {
  const stats = [{
    value: '15+',
    label: 'Years Experience'
  }, {
    value: '$2B+',
    label: 'Assets Advised'
  }, {
    value: '500+',
    label: 'Clients Scaled'
  }, {
    value: '98%',
    label: 'Retention Rate'
  }];
  return <section id="about" className="py-24 relative z-10 border-t border-white/5" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-11">
          {/* Left Content */}
          <div data-id="element-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/20 mb-6" data-id="element-13">
              <span className="text-sm font-medium text-blue-400" data-id="element-14">
                About Scale Finance
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-15">
              Redefining Wealth Creation for Australians
            </h2>
            <p className="text-lg text-slate-400 mb-6 leading-relaxed" data-id="element-16">
              Founded on the principle that elite financial strategies shouldn't
              be reserved for the ultra-wealthy, Scale Finance Strategies brings
              institutional-grade modeling and advisory to ambitious
              Australians.
            </p>
            <p className="text-lg text-slate-400 mb-8 leading-relaxed" data-id="element-17">
              We leverage cutting-edge technology and decades of market
              experience to build resilient portfolios, optimize tax structures,
              and accelerate your journey to financial independence.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-18">
              {['Fiduciary standard: Your interests always come first', 'Data-driven, emotion-free investment strategies', 'Holistic approach integrating tax, wealth, and cash flow'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-19">
                  <CheckCircleIcon className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-20" />
                  <span className="text-slate-300" data-id="element-21">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Right Content - Stats & Visual */}
          <div className="relative" data-id="element-22">
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/20 to-cyan-600/20 rounded-3xl blur-3xl -z-10" data-id="element-23"></div>
            <div className="bg-white/5 border border-white/10 rounded-3xl p-8 backdrop-blur-md" data-id="element-24">
              <div className="grid grid-cols-2 gap-8" data-id="element-25">
                {stats.map((stat, index) => <div key={index} className="text-center p-6 rounded-2xl bg-white/5 border border-white/5 hover:bg-white/10 transition-colors" data-id="element-26">
                    <div className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400 mb-2" data-id="element-27">
                      {stat.value}
                    </div>
                    <div className="text-sm font-medium text-slate-400 uppercase tracking-wider" data-id="element-28">
                      {stat.label}
                    </div>
                  </div>)}
              </div>

              <div className="mt-8 p-6 rounded-2xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white" data-id="element-29">
                <h3 className="text-xl font-semibold mb-2" data-id="element-30">Our Mission</h3>
                <p className="text-blue-100" data-id="element-31">
                  To democratize elite financial strategies and empower 10,000
                  Australians to achieve complete financial sovereignty by 2030.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}